import Icon, { IconType } from 'components/Icon';
import * as S from './styles';

interface PillProps {
	label: string;
	variant?: 'default' | 'deleted' | 'muted';
	onClick?: (e: React.MouseEvent) => void;
	onRemove?: () => void;
	tooltip?: string;
}

const Pill = ({ label, variant = 'default', onClick, onRemove, tooltip }: PillProps) => {
	// When onRemove is present, always use split layout (two sibling elements)
	if (onRemove) {
		const clickable = !!onClick;
		return (
			<S.SplitWrapper>
				<S.SplitLabel
					as={clickable ? 'button' : 'span'}
					$variant={variant}
					$clickable={clickable}
					title={tooltip}
					onClick={onClick}
					type={clickable ? 'button' : undefined}
				>
					<S.Label>{label}</S.Label>
				</S.SplitLabel>
				<S.SplitRemove $variant={variant} type="button" onClick={onRemove} aria-label="Remove">
					<Icon type={IconType.CLOSE} width={10} height={10} />
				</S.SplitRemove>
			</S.SplitWrapper>
		);
	}

	const clickable = !!onClick;
	const Wrapper = clickable ? 'button' : 'span';

	return (
		<S.Base
			as={Wrapper}
			$variant={variant}
			$clickable={clickable}
			title={tooltip}
			onClick={onClick}
			type={clickable ? 'button' : undefined}
		>
			<S.Label>{label}</S.Label>
		</S.Base>
	);
};

export default Pill;
